import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrayCleanPipe } from '@exl-ng/mulo-common';

import { SharedModule } from '../../shared/shared.module';

import { EntityLocationsComponent } from './entity-locations.component';

@NgModule({
    imports: [CommonModule, ArrayCleanPipe, SharedModule, EntityLocationsComponent],
    exports: [EntityLocationsComponent],
})
export class EntityLocationsModule {}
